import React from 'react';
import { Modal } from 'antd';

export type AuthModalFormType = 'login' | 'register';

interface AuthModalProps {
    open: boolean;
    loading?: boolean;
    formType: AuthModalFormType;
    minWidth?: number;
    maxWidth?: number;
    onCancel: () => void;
    onChangeFormType: (type: AuthModalFormType) => void;
    emailForm: React.ReactNode;
    loginForm: React.ReactNode;
}

export const AuthModal: React.FC<AuthModalProps> = ({
    open,
    loading,
    formType,
    minWidth = 320,
    maxWidth = 480,
    onCancel,
    onChangeFormType,
    emailForm,
    loginForm,
}) => {
    return (
        <Modal
            open={open}
            width="auto"
            style={{ minWidth, maxWidth }}
            footer={null}
            closable
            onCancel={onCancel}
            confirmLoading={loading}
        >
            {formType === 'register' ? emailForm : loginForm}
        </Modal>
    );
};
